import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import { switchToLevel } from "../ai-first/helpers";

const actionTexts = ["image: bauhaus", "\nimage: bauhaus colors"];

const imageTour: StepType[] = [
	{
		selector: ".author-root",
		position: "center",
		content: () => <TourStepContent description={() => <strong>{text.tourSteps.imagesTitleAccessibility}</strong>} />,
		action: () => {
			switchToLevel(3);
			fireClearCodeEvent();
		},
	},
	{
		selector: "#action-control-files",
		content: () => (
			<TourStepContent description={() => text.tourSteps.imagesStoredUnderFiles} />
		),
		actionAfter: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
		},
	},
	{
		selector: "#file-uploader",
		content: () => (
			<TourStepContent description={() => text.tourSteps.imagesAltTextDescription} />
		),
		actionAfter: () => {
			const toggleFiles = document.getElementById("action-control-files");
			toggleFiles?.click();
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.imagesAddImagePrefix}{" "}
						<span className="qp-tour-modifier">image:</span> {text.tourSteps.imagesAddImageSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			typeSomeText({ text: "" });
			setTimeout(() => {
				fireClearCodeEvent();
				typeSomeText({ text: actionTexts[0], openAutoComplete: true });
			}, 150);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.imagesMultipleAccessibility} />
		),
		action: () => {
			typeSomeText({ text: "" });
			setTimeout(() => {
				fireClearCodeEvent();
				typeSomeText({ text: `${actionTexts[0]}${actionTexts[1]}`, openAutoComplete: true });
			}, 150);
		},
	},
];

export default imageTour;
